module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAZCAYAAADNAiUZAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACMSURBVEiJ7dWxDcIwEADAk8gAKaHLCGyQFdgENgBGSMcWjMAoGQE2gCJBMh0k8iOBX3r5XVj3b1ky82KH67iGxQX3MfdR6NowaYFD4P4bcFPg/4QrbLDNCN+S+vAs0k4isq/QoUWdYUqGK26SfZfJeQFDH1MBC/hxhP+nvw/CeQq4mImusMQJx3cPPQDAiGmYlz8osgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Btn/next.png
// module id = +f8l
// module chunks = 0